import { Building2, LayoutDashboard, List, LogOut, Settings, Users, X } from "lucide-react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

import { clearUser } from "../redux/users/usersSlice";
import classes from "./Sidebar.module.css";
import logo from "../assets/login/teletrace-logo-white.png";

const ICON_SIZE = 22;
const ICON_STROKE = 1.75;

const navItems = [
	{ icon: LayoutDashboard, label: "Dashboard", to: "/dashboard" },
	{ icon: Building2, label: "Organizations", to: "/organizations" },
	{ icon: Users, label: "Users", to: "/users" },
	{ icon: List, label: "Activity Logs", to: "/activity-logs" },
	{ icon: Settings, label: "Settings", to: "/settings" },
];

const SuperAdminSidebar = ({ isOpen = false, onClose }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (typeof onClose === "function") onClose();
	}, [location.pathname, onClose]);

	const handleSignOut = () => {
		dispatch(clearUser());
		localStorage.clear();
		navigate("/login", { replace: true });
	};

	return (
		<>
			<button
				aria-label="Close navigation"
				className={`${classes.backdrop} ${isOpen ? classes.backdropOpen : ""}`}
				onClick={onClose}
				type="button"
			/>
			<aside className={`${classes.sidebar} ${isOpen ? classes.sidebarOpen : ""}`}>
				<div className={classes.top}>
					<div className={classes.logoRow}>
						<Link className={classes.logoLink} to="/dashboard">
							<img alt="TeleTrace" className={classes.logo} src={logo} />
						</Link>
						<button aria-label="Close navigation" className={classes.closeButton} onClick={onClose} type="button">
							<X color="#9FB6C4" size={20} strokeWidth={2} />
						</button>
					</div>

					<div className={classes.roleBadgeWrap}>
						<span className={classes.roleBadge}>Super Admin</span>
					</div>

					<nav className={classes.nav}>
						{navItems.map((item) => {
							const Icon = item.icon;
							return (
								<NavLink
									className={({ isActive }) =>
										isActive ? `${classes.link} ${classes.linkActive}` : classes.link
									}
									key={item.to}
									to={item.to}>
									{({ isActive }) => (
										<>
											<span className={classes.icon}>
												<Icon
													color={isActive ? "#27B99A" : "#9FB6C4"}
													size={ICON_SIZE}
													strokeWidth={ICON_STROKE}
												/>
											</span>
											<span>{item.label}</span>
										</>
									)}
								</NavLink>
							);
						})}
					</nav>
				</div>

				<button className={classes.signOut} onClick={handleSignOut} type="button">
					<LogOut color="#9FB6C4" size={20} strokeWidth={ICON_STROKE} />
					Sign Out
				</button>
			</aside>
		</>
	);
};

export default SuperAdminSidebar;
